import { render, staticRenderFns } from "./VisualizarConvenio.vue?vue&type=template&id=323e06b9&"
import script from "./VisualizarConvenio.vue?vue&type=script&lang=js&"
export * from "./VisualizarConvenio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports